import { ImDatabase } from 'react-icons/im';
import type { AgentApiAnalysisInsightsConsultantTableRow } from '@/types/serializers';
import InsightEmptyState from './InsightEmptyState';
import { CONSULTANT_TABLE_COLUMNS } from './insightStageDefinitions';

interface Props {
  rows: AgentApiAnalysisInsightsConsultantTableRow[];
}

/**
 * 担当者別の平均リードタイム明細テーブル。
 * 表示列は CONSULTANT_TABLE_COLUMNS の順で、行は API のレスポンス順（担当者名昇順）。
 */
export default function InsightConsultantTable({ rows }: Props) {
  const isEmpty = rows.length === 0;
  const columnCount = CONSULTANT_TABLE_COLUMNS.length + 1;

  return (
    <div className="overflow-hidden rounded-sm border border-solid border-border bg-white">
      <div className="overflow-x-auto">
        <table className="w-full table-fixed border-collapse">
          <thead>
            <tr className="border-b border-solid border-border bg-gray">
              <th className="w-[200px] px-md py-sm text-left align-middle text-heading-xxs text-sub">
                担当者
              </th>
              {CONSULTANT_TABLE_COLUMNS.map((col) => (
                <th
                  key={col.key}
                  className="px-md py-sm text-center align-middle text-heading-xxs text-sub"
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isEmpty && (
              <tr>
                <td colSpan={columnCount} className="p-0">
                  <InsightEmptyState
                    icon={ImDatabase}
                    description="条件を変更すると、ここに表示されます"
                  />
                </td>
              </tr>
            )}
            {rows.map((row) => {
              // ステージキー → 日数の Map に正規化して O(1) 参照する
              const stageDays = new Map(row.stages.map((s) => [s.key, s.days]));
              return (
                <tr
                  key={row.organization_user_id}
                  className="border-b border-solid border-border last:border-b-0"
                >
                  <td className="w-[200px] p-xs align-middle text-body-sm text-gray-700">
                    <div className="flex items-center gap-sm">
                      <span className="inline-block size-8 shrink-0 rounded-full bg-gray-300" />
                      <span className="min-w-0 flex-1 truncate" title={row.name}>
                        {row.name}
                      </span>
                    </div>
                  </td>
                  {CONSULTANT_TABLE_COLUMNS.map((col) => (
                    <td
                      key={col.key}
                      className="px-md py-xs text-center align-middle text-body-sm text-sub"
                    >
                      {stageDays.get(col.key) ?? 0}日
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
